module.exports = __webpack_public_path__ + "img/11_newModelWorker_lyy.b0e691ff.png";